import {useRef} from 'react';

import {extractRunFilterErrorMessage} from './errors';

/**
 * True once the backend has rejected `filterKey` as an invalid run filter, and
 * stays true until `filterKey` changes.
 *
 * "Latched" = sticky rather than a live read of `error`. Both callers poll, and
 * a poll that is in flight or that succeeds does not necessarily carry the
 * rejection forward in `error`, while `data` still holds the payload from the
 * rejected read. A plain `error != null` check would therefore flip back to
 * false between polls and resume deriving off that payload. Keying on the
 * filter is what clears it: a new filter is a new question, so the previous
 * rejection no longer applies.
 */
export function useLatchedInvalidRunFilter(
  error: unknown,
  filterKey: string
): boolean {
  const keyRef = useRef<string | null>(null);
  const latchRef = useRef(false);
  if (keyRef.current !== filterKey) {
    keyRef.current = filterKey;
    latchRef.current = false;
  }
  if (extractRunFilterErrorMessage(error) != null) {
    latchRef.current = true;
  }
  return latchRef.current;
}
